import { render, staticRenderFns } from "./ContactAttendancesHistory.vue?vue&type=template&id=08c4fd4a"
import script from "./ContactAttendancesHistory.vue?vue&type=script&lang=js"
export * from "./ContactAttendancesHistory.vue?vue&type=script&lang=js"
import style0 from "./ContactAttendancesHistory.vue?vue&type=style&index=0&id=08c4fd4a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerIos,QIcon,QVirtualScroll,QCard});
